/**
 * Vue app for cartridge estimator form.
 *
 * Note: Vue library must be loaded before this script.
 *
 * @see form-cartridge-estimator.liquid
 */
document.addEventListener('DOMContentLoaded', function() {
  var cartridges = [40, 50, 200, 375, 400, 490, 600];

  var cartridgeCoverage = {
    oneEighth: {
      imperial: [17, 21, 83, 155, 166, 201, 249],
      metric: [5, 6.3, 25.2, 47.2, 50.4, 61.1, 75.6]
    },
    threeSixteenths: {
      imperial: [7.4, 9.2, 37, 69, 74, 89, 111],
      metric: [2.2, 2.8, 11.2, 21, 22.4, 27.2, 33.6]
    },
    oneQuarter: {
      imperial: [4.1, 5.2, 21, 39, 41, 50, 62],
      metric: [1.3, 1.6, 6.3, 11.8, 12.6, 15.3, 18.7]
    },
    fiveSixteenths: {
      imperial: [2.7, 3.3, 13, 25, 27, 32, 40],
      metric: [0.8, 1, 4, 7.6, 8.1, 9.8, 12.1]
    },
    threeEighths: {
      imperial: [1.8, 2.3, 9, 17, 18, 22, 28],
      metric: [0.6, 0.7, 2.8, 5.2, 5.6, 6.8, 8.4]
    },
    oneHalf: {
      imperial: [1, 1.3, 5.2, 10, 10, 13, 16],
      metric: [0.3, 0.4, 1.6, 3.1, 3.1, 3.8, 4.7]
    }
  }

  var labels = {
    oneEighth: {
      imperial: '1/8',
      metric: '0.3',
      hint: 'thin'
    },
    threeSixteenths: {
      imperial: '3/16',
      metric: '0.48',
      hint: ''
    },
    oneQuarter: {
      imperial: '1/4',
      metric: '0.6',
      hint: 'most common'
    },
    fiveSixteenths: {
      imperial: '5/16',
      metric: '0.8',
      hint: ''
    },
    threeEighths: {
      imperial: '3/8',
      metric: '0.95',
      hint: ''
    },
    oneHalf: {
      imperial: '1/2',
      metric: '1.3',
      hint: 'thick'
    }
  }

  var diameters = Object.keys(labels);

  /**
   * Helper to format bead length labels.
   */
  function formatBeadLength(value, units) {
    var length = Number(value).toFixed(0);
    if (units === 'imperial') {
      length += ' ' + (length > 1 ? 'feet' : 'foot');
    }
    else {
      length += ' ' + (length > 1 ? 'meters' : 'meter');
    }
    return length;
  }

  /**
   * Helper to format bead diameter labels.
   */
  function formatBeadDiameter(id, units, hideHint) {
    var label = labels[id][units];
    var suffix = units === 'imperial' ? 'inch' : 'cm';
    var hint = labels[id]['hint'];
    return label + ' ' + suffix + (hint && !hideHint ? ' (' + hint + ')' : '');
  }

  /**
   * Helper to determine cartridges required based on inputs.
   */
  function calculateResults(length, diameter, pattern, units) {
    var sizes = [40, 50, 200, 400, 490];
    var coverage = cartridgeCoverage[diameter][units];
    return sizes.map(function(size) {
      var sizeIndex = cartridges.indexOf(size);
      var lengthPerCartridge = coverage[sizeIndex];
      var cartridgesRequired = length / lengthPerCartridge;
      if (pattern === 'wave') {
        cartridgesRequired = cartridgesRequired * 1.6;
      }
      cartridgesRequired = Math.ceil(cartridgesRequired);
      return {
        size: size,
        iconHeight: calculateIconHeight(size),
        cartridges: cartridgesRequired === 1 ? '1 cartridge' : cartridgesRequired + ' cartridges'
      }
    });
  }

  /**
   * Helper to calculate icon height based on cartridge volume.
   */
  function calculateIconHeight(size) {
    var increase = (size / 40) * 3.3
    return Math.ceil(40 + increase);
  }

  /**
   * Helper to save state in local storage.
   */
  function persistState(state) {
    var props = {};
    ['units', 'length', 'diameter', 'pattern'].forEach(function(prop) {
      props[prop] = state[prop];
    });
    window.location.hash = 'cartridge-estimator:' + window.btoa(JSON.stringify(props));
  }

  var initialState = {
    units: 'imperial',
    length: '200',
    diameter: 'oneQuarter',
    pattern: 'wave'
  }

  // Load state from local storage.
  if (window.location.hash && window.location.hash.indexOf('#cartridge-estimator') > -1) {
    try {
      var encoded = window.location.hash.replace('#cartridge-estimator:', '');
      var decoded = JSON.parse(window.atob(encoded));
      for (var key in initialState) {
        if (decoded[key]) {
          initialState[key] = decoded[key];
        }
      }
    }
    catch (error) {}
  }

  /**
   * Main Vue application.
   */
  new Vue({
    el: '#cartridge-estimator',
    delimiters: ['[[', ']]'],
    data: function() {
      return initialState
    },
    computed: {
      diameters: function() {
        var units = this.units;
        return diameters.map(function(id) {
          return { id: id, label: formatBeadDiameter(id, units) }
        })
      },
      currentDiameter: function() {
        return formatBeadDiameter(this.diameter, this.units, true)
      },
      currentLength: function() {
        return formatBeadLength(this.length, this.units)
      },
      lengthUnits: function() {
        return this.units === 'imperial' ? 'feet' : 'meters'
      },
      results: function() {
        return calculateResults(this.length, this.diameter, this.pattern, this.units)
      }
    },
    watch: {
      units: function() {
        persistState(this)
      },
      length: function() {
        persistState(this)
      },
      diameter: function() {
        persistState(this)
      },
      pattern: function() {
        persistState(this)
      }
    }
  });
});
